<template>
    <div>
        <div :class="{ [className]: true }" id="supsis-badge-unread-count">
            {{ badge < 1000 ? badge : "1K+" }}
        </div>
    </div>
</template>
<script>
export default {
    name: "SupsisBadge",
    props: {
        badge: {
            type: String,
            required: true,
        },
        className: {
            type: String,
            default: "",
        },
    },
};
</script>
<style lang="scss" scoped>
.email-unread-count {
    margin-left: 22px;
    margin-top: -29px;
    color: white;
    font-weight: 600;
    z-index: 9;
    position: relative;
    margin-bottom: 13px;
    background-color: #ce0404;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
}
.activty-undread-count{
    margin-left: 12px;
    color: white;
    font-weight: 600;
    z-index: 9;
    position: absolute;
    margin-bottom: 13px;
    background-color: #ce0404;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
}
</style>
